import React, { useEffect } from 'react'

import { useAPIGetPerencanaanSatuanPendidikanV2Options } from 'api/kinerja/pengawas-sekolah/perencanaan'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { TSatuanPendidikanV2Item } from 'types/kinerja-ps-pegawai'
type TUseSatuanPendidikanHooks = {
  satuanPendidikanData: TSatuanPendidikanV2Item[]
}
export const useSatuanPendidikanV2 = (
  rhkIds?: string[],
  onSuccess?: (data: TSatuanPendidikanV2Item[]) => void
): TUseSatuanPendidikanHooks => {
  const { isHavePeriod, period } = usePeriodContext()

  const {
    data: perencanaanSatuanPendidikanResponse,
    isSuccess: isPerencanaanSatuanPendidikanSuccess,
  } = useAPIGetPerencanaanSatuanPendidikanV2Options({
    periodeId: period.id,
    rhkIds,
    opts: {
      enabled: isHavePeriod && Boolean(rhkIds?.length),
    },
  })

  const satuanPendidikanData = React.useMemo(() => {
    if (isPerencanaanSatuanPendidikanSuccess) {
      return perencanaanSatuanPendidikanResponse?.data ?? []
    }

    return []
  }, [
    isPerencanaanSatuanPendidikanSuccess,
    perencanaanSatuanPendidikanResponse?.data,
  ])

  useEffect(() => {
    if (isPerencanaanSatuanPendidikanSuccess) {
      onSuccess?.(satuanPendidikanData)
    }
  }, [isPerencanaanSatuanPendidikanSuccess, onSuccess, satuanPendidikanData])

  return {
    satuanPendidikanData,
  }
}
